export const store = {
  storage : {
    ionic : null,
  },
	state: {
		app_token: null,
		user: {},
		multi: {},
    client: {
      id: '',
      negoceId: '',
    },
		api: 0,
		isSync: false,
		onboarding: {},
		badge: {
			type: '',
      refCulture: '',
      refDestination: '',
      content: {},
		},
    quiz: 0,
    notif: {},
		push_ok: null,
	},
	data: {
		referentiel: {},
		cours: {},
		negoce: {
			date: 0,
			list: [],
			request: [],
			suggest: [],
			clients: {},
		},
		histo: {
			date: 0,
      list: {},
		},
		live: {
			date: 0,
		},
		quiz: {
			date: 0,
		},
		date: 0,
		now: 0,
	},
};